window.SETTINGS = {
    BREAKPOINT: null,
    BREAKPOINTS: {},
};

jQuery(document).ready(function($) {

    window.SETTINGS.BREAKPOINTS.XL_MIN = 1920;
    window.SETTINGS.BREAKPOINTS.LG_MAX = window.SETTINGS.BREAKPOINTS.XL_MIN - 1;
    window.SETTINGS.BREAKPOINTS.LG_MIN = 1440;
    window.SETTINGS.BREAKPOINTS.MD_MAX = window.SETTINGS.BREAKPOINTS.LG_MIN - 1;
    window.SETTINGS.BREAKPOINTS.MD_MIN = 1024;
    window.SETTINGS.BREAKPOINTS.SM_MAX = window.SETTINGS.BREAKPOINTS.MD_MIN - 1;
    window.SETTINGS.BREAKPOINTS.SM_MIN = 768;
    window.SETTINGS.BREAKPOINTS.XS_MAX = window.SETTINGS.BREAKPOINTS.SM_MIN - 1;

    //disable right click on images
    $('body').on("contextmenu",function(e){
	e.preventDefault();
    });

    // Enable Bootstrap tooltips on page load
    initTooltips();

    // Dismiss success alerts after 4 seconds (except the volunteer-rebate
    // pending-credit banner, which must persist until the user closes it)
    var $alert = $('.alert.alert-success:not(.promo-pending-alert)');
    if ($alert.length) {
        setTimeout(function () {
            $alert.fadeOut(500, function () {
                $(this).remove(); // Removes the element from the DOM
            });
        }, 4000);
    }

    if (typeof Livewire !== 'undefined' && Livewire.hook) {
	// Ensure Livewire updates re-instantiate tooltips
	Livewire.hook('morph.updated', ({ el, component }) => {
            initTooltips({ recreate: true });
	})

	// Ensure Livewire updates instantiate functionalities
	Livewire.hook('morphed', ({ el, component }) => {
	    // Password visibility toggle
            bindPasswordToggles();
	    // Success alerts auto-dismiss
            dismissSuccessAlerts();
	    // Enable Tooltips
	    initTooltips();
	    // Enable remove merchant modal
	    confirmRemoveMerchantModal();
	    
	})

	// Open user auto-login in blank tab, called from SAC dashboard 
	Livewire.on('open-login-url', ({ url }) => {
	    window.open(url, '_blank');
	});


	/*** Login as user Modal ***/
	let loginAsUserId = null;

	const $loginModal = $('#confirmLoginAsUserModal');
	if (!$loginModal.length) {
	    return;
	}

	// When modal is about to be shown, grab userId from triggering button
	$loginModal.on('show.bs.modal', function (event) {
	    const $trigger = $(event.relatedTarget);

	    loginAsUserId = $trigger.data('user-id') ?? null;
	    const userEmail = $trigger.data('user-email') ?? '';

	    $loginModal.find('.login-as-user-email').text(userEmail);
	});

	// On Confirm login as user, dispatch Livewire event
	$('#confirmLoginAsUserBtn').on('click', function () {
	    if (!loginAsUserId) {
		return;
	    }

	    Livewire.dispatchTo(
		'user-table',
		'loginAsUserEvent',
		{ userId: loginAsUserId }
	    );

	    // Dismiss the modal
	    const modalInstance = bootstrap.Modal.getInstance($loginModal[0]);
	    modalInstance.hide();

	    loginAsUserId = null;
	});

	
	/*** Send reset password email modal ***/
	let sendResetUserId = null;

	const $modal = $('#confirmSendResetModal');
	if (!$modal.length) {
            return;
	}
	// When modal is about to be shown, grab userId from triggering button
	$modal.on('show.bs.modal', function (event) {
	    const $trigger = $(event.relatedTarget);

	    sendResetUserId = $trigger.data('user-id') ?? null;
	    const userEmail = $trigger.data('user-email') ?? '';

	    $modal.find('.send-reset-user-email').text(userEmail);
	});
	
	// On Confirm set password reset, dispatch Livewire event
	$('#confirmSendResetBtn').on('click', function () {
            if (!sendResetUserId) {
		return;
            }

            Livewire.dispatchTo(
		'user-table',
		'sendPasswordResetEvent',
		{ userId: sendResetUserId }
            );

	    // Dismiss the modal
	    const modalInstance = bootstrap.Modal.getInstance($modal[0]);
	    modalInstance.hide();
	    
            sendResetUserId = null;
	});

	// Show Success alert once password reset is sent
	Livewire.on('show-success-confirmation', ({ msg }) => {
	    const alert = $('.confirmation-alert');
	    alert.find('.alert-content').html(msg);
	    alert.addClass('alert').removeClass('d-none').show();
	    dismissSuccessAlerts();
	});
    }

    // Confirm remove merchant modal
    function confirmRemoveMerchantModal() {
	// Confirm remove merchant modal
	const modalEl = document.getElementById('confirmRemoveMerchantModal');
	if (!modalEl) return;


	const modal = new bootstrap.Modal(modalEl, {
	    backdrop: false,
	    keyboard: false,
	    focus: true,
	});

	// Livewire -> open modal
	window.addEventListener('open-remove-merchant-modal', function () {
	    modal.show();
	});

	// Close modal after successful removal (optional)
	window.addEventListener('merchant-removed', function () {
	    modal.hide();
	});
    }    
    
    // Bootstrap 5 ships vanilla tooltips only — no $.fn.tooltip jQuery plugin.
    function initTooltips({ recreate = false } = {}) {
        if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) return;
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
            if (recreate) {
                bootstrap.Tooltip.getInstance(el)?.dispose();
                new bootstrap.Tooltip(el);
            } else {
                bootstrap.Tooltip.getOrCreateInstance(el);
            }
        });
    }

    // Dismiss success alerts (except the volunteer-rebate pending-credit banner,
    // which must persist until the user closes it)
    function dismissSuccessAlerts() {
        var $alerts = $('.alert.alert-success:not(.promo-pending-alert)');
        if (!$alerts.length) return;
        // give users a moment to see it
        setTimeout(function () {
            $alerts.fadeOut(500, function () {
                $(this).addClass('d-none');
            });
        }, 4000); // 4 Seconds
    }
    dismissSuccessAlerts();
    
    // View passwords in plain text
    function bindPasswordToggles() {
        $('.password-visibility-toggle')
            .off('click')
            .on('click', function() {
		let pwd = $(this).siblings('input[type="password"], input[type="text"]');
		pwd.attr('type', pwd.attr('type') === 'password' ? 'text' : 'password');
            });
    } 
    bindPasswordToggles();
    
    //this class is applying css transition duration of 0 to prevent animating from resetting when refreshing the page.
    $('body').removeClass('preload');

    $('body').on('click', 'a', function (e) {
        if ($(this).attr('href') == " " || $(this).attr('href') == "" || $(this).attr('href') == "#") {
            e.preventDefault();
        }
    });

    $(window).on('scroll', (e, index) => {
        $(document).trigger('scroll:active');

        window.dispatchEvent(new Event("window.scroll"));
    });

    //dispatch a single event for window resize that can be accessed by anyone.
    $(window).on('resize', (e) => {

        window.dispatchEvent(new Event("window.resize"));

        let breakpoints = [
            window.SETTINGS.BREAKPOINTS.SM_MIN,
            window.SETTINGS.BREAKPOINTS.MD_MIN,
            window.SETTINGS.BREAKPOINTS.LG_MIN,
            window.SETTINGS.BREAKPOINTS.XL_MIN,
        ];

        let breakpoint;
        let viewPortSize = $('html').outerWidth(true);

        if (viewPortSize < breakpoints[0]) {
            breakpoint = String(breakpoints[0] - 1) + "-";
        }

        for (let i in breakpoints) {
            if (breakpoints[Number(i) + 1] != undefined && viewPortSize >= breakpoints[i] && viewPortSize < breakpoints[Number(i) + 1]) {
                breakpoint = String(breakpoints[i]) + "-" + String(breakpoints[Number(i) + 1] - 1);
            }
            if (viewPortSize >= breakpoints[breakpoints.length - 1]) {
                breakpoint = String(breakpoints[i]) + "+";
            }
        }

        if (window.SETTINGS.BREAKPOINT != breakpoint) {
            window.SETTINGS.BREAKPOINT = breakpoint;

            let eventDispatch = new CustomEvent("breakpointChanged", {bubbles: true, detail: {
                    breakpoint: breakpoint
                }
            });

            window.dispatchEvent(eventDispatch);
        }
    });

    //force a resize to trigger breakpoints changes
    setTimeout(function(){$(window).resize();},100);

     $('.nano').nanoScroller();
});
